import { useEffect } from 'react';
import { sendEventBeacon } from '../../../../api/closeTabApiClien';

export enum EventTypeKey {
    AbandonedTravel = 'abandoned_travel',
    AbandonedGreencard = 'abandoned_greencard',
    AbandonedOscpv = 'abandoned_oscpv',
}

export interface TrackingParams {
    eventTypeKey: EventTypeKey;
    email?: string;
    url: string;
}

const eventTypeValues: Record<EventTypeKey, string> = {
    [EventTypeKey.AbandonedTravel]: 'Travel',
    [EventTypeKey.AbandonedGreencard]: 'Green Card',
    [EventTypeKey.AbandonedOscpv]: 'OSCPV',
};

export const useTabCloseTracking = (
    email: string | undefined,
    eventTypeKey: EventTypeKey
) => {
    useEffect(() => {
        const handleTabClose = () => {
            if (email) {
                const keyValue = email;

                const params: { name: string; value: string | Date }[] = [
                    { name: 'email', value: keyValue },
                    { name: 'url', value: window.location.href },
                ];

                const value = eventTypeValues[eventTypeKey];

                if (value) {
                    params.push({ name: 'name', value });
                }

                sendEventBeacon({
                    isDelayed: true,
                    eventTypeKey,
                    keyValue,
                    params,
                });
            }
        };

        window.addEventListener('unload', handleTabClose);

        return () => {
            window.removeEventListener('unload', handleTabClose);
        };
    }, [email, eventTypeKey]);
};
